// CREATE PASSWORD
let createButtonPass = document.getElementById("btn_create_pass");
createButtonPass &&createButtonPass.addEventListener("click", function () {
      let inputPass = document.getElementById("create_new_pass");
      let inputPassConfirm = document.getElementById("confirm_new_pass");

      let inputPassMsg = document.getElementById("create_pass_error");
      let inputPassConfirmMsg = document.getElementById(
        "confirm_new_pass_error"
      );
      let createPassPrivacyPolicy = document.querySelector("#create_pass_privacy_policy");
      let createPassPrivacyPolicyMsg = document.querySelector("#create_pass_privacy_policy_error");

      if (!validateOnEmpty(inputPass)) {
        inputPassMsg.classList.add("show_msg");
      } else {
        inputPassMsg.classList.remove("show_msg");
      }
      if (!validateOnEmpty(inputPassConfirm)) {
        inputPassConfirmMsg.innerText = "Please enter confirm password!";
        inputPassConfirmMsg.classList.add("show_msg");
        return;
      } else {
        inputPassConfirmMsg.classList.remove("show_msg");
      }
      if (inputPass.value !== inputPassConfirm.value) {
        inputPassConfirmMsg.innerText =
          "Confirmed password does not match password!";
        inputPassConfirmMsg.classList.add("show_msg");
        return;
      } else {
        inputPassConfirmMsg.classList.remove("show_msg");
      }
      if(createPassPrivacyPolicy != null) {
        if (!getChecboxActive(createPassPrivacyPolicy)) {
          createPassPrivacyPolicyMsg.classList.add("show_msg");
          return;
        } else {
          createPassPrivacyPolicyMsg.classList.remove("show_msg");
          createPassRequest(inputPass.value, inputPassConfirm.value, getChecboxActive(createPassPrivacyPolicy));
        }
      } else {
        createPassRequest(inputPass.value, inputPassConfirm.value, false);
      }
    });
function createPassRequest(pass, passConfirm, privacyPolicy) {
  const request = new XMLHttpRequest();
  const url = document
    .querySelector("#create_pass_url")
    .getAttribute("data-create-pass");
  const params =
    "ResetPasswordForm[password]=" +
    pass +
    "&ResetPasswordForm[password_confirmation]=" +
    passConfirm +
    "&ResetPasswordForm[terms_and_conditions]=" +
    privacyPolicy +
    "&_csrf=" +
    jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        console.log("request response", request.responseText);
        let response = JSON.parse(request.responseText);
        window.scrollTo({ top: 0, behavior: "smooth" });
        if (response.status === "ok") {
          window.location.href = response.message;
        }
        if (response.status === "error") {
          let responseErrorsMsg = createErrorsMsg(response.errors);
          showMsg("msg_error_create_pass", responseErrorsMsg);
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}
// END CREATE PASSWORD
